import { useState, useEffect } from 'react';
import './styles.css';
import { useDebounce } from '../../../helpers';
import PropTypes from 'prop-types';
import TextInput from '../../Inputs/TextInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useLeadForm } from '../../../context/leadform';
import { PropertyLocationOptions } from '../../../Leadform/options';
import Select from '../../Inputs/Select';

function AddressStep() {
    const { updateValue, responses, step, setStep, sessionKey, setSessionKey } = useLeadForm();

    const [postcode, setPostcode] = useState();
    const [showForm, setShowForm] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [loading, setLoading] = useState(false);
    const [suggestions, setSuggestions] = useState([]);

    const manualConst = "Cant find your address? Enter it manually."

    const debouncedPostcode = useDebounce(postcode, 300);

    useEffect(() => {
        const lookupPostcode = (postcode) => {
            setLoading(true);
            fetch(`/wp-json/wordpress-leadform/v1/address?postcode=${postcode}?session=${sessionKey}`, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((response) => {
                    console.log(response);
                    const addresses = [
                        ...response.addresses,
                        manualConst
                    ]
                    setSuggestions(addresses)
                    setSessionKey(response.session)
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false)
                    setShowForm(true)
                });
        }

        if (validatePostcode(debouncedPostcode)) {
            lookupPostcode(debouncedPostcode);
        }
    }, [debouncedPostcode])

    const selectAddress = (address) => {
        setSuggestions([])
        if (address == manualConst) {
            setShowForm(true)
        } else {
            updateValue('address', address)
            setShowConfirmation(true)
        }
    }

    const validatePostcode = (postcode) => {
        let pattern = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/i
        return pattern.test(postcode);
    }

    return (
        <div className="Step AddressStep">
            {!showForm && !showConfirmation && (
                <>
                    <h2>Where is the property located?</h2>
                    <p>
                        Enter your postcode to compare cash buyers who purchase properties in your area
                    </p>
                    <div className='TextInput'>
                        {loading && <FontAwesomeIcon className='spinner' icon={faSpinner} />}
                        <input name="postcode" value={postcode} onChange={(e) => setPostcode(e.target.value)} placeholder='Enter your postcode...' />
                    </div>
                    {suggestions.length > 0 && (
                        <ul className='Suggestions'>
                            {suggestions.map((suggestion, index) => (
                                <li key={index} onClick={() => selectAddress(suggestion)}>
                                    <b>{suggestion}</b>
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
            {showConfirmation && !showForm && (
                <>
                    <h2>Please confirm your address</h2>
                    <p>Confirm it below so we can continue.</p>
                    <div className='Confirmation'>
                        <p><b>The property address: </b></p>
                        {responses.address.split(',').map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>
                    <div className="Buttons">
                        <button className='Primary' onClick={() => setStep(step + 1)}>Yes, that's correct</button>
                        <button className='Secondary' onClick={() => setShowForm(true)}>No, I'll enter it manually</button>
                    </div>
                </>
            )
            }
            {
                showForm && (
                    <>
                        <h2>Please confirm your address</h2>
                        <div className='Form'>
                            <TextInput label='Address Line 1' statekey='line1' />
                            <TextInput label='Address Line 2' statekey='line2' />
                            <TextInput label='Town' statekey='town' />
                            <TextInput label='County' statekey='county' />
                            <TextInput label='Postcode' statekey='postcode' />
                            <Select options={PropertyLocationOptions} label='Country' statekey='country' />
                        </div>
                        <div className="Buttons">
                            <button className='Primary' onClick={() => setStep(step + 1)}>Next</button>
                        </div>
                    </>
                )
            }
        </div >
    )
}

export default AddressStep

